// Arabic Solutions index — mirrors the English SolutionsIndex.
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArContactCTA } from "@/pages/ar/_ArShared";
import { SOLUTIONS_AR, SOLUTIONS_INDEX_INTRO_AR } from "@/data/solutions-ar";

export default function SolutionsIndexAr() {
  const list = Object.values(SOLUTIONS_AR);
  return (
    <div data-testid="solutions-index-ar">
      <Seo title="الحلول" description="معظم الجزء الصعب مبني بالفعل. أحضروا علامتكم وقواعد عملكم، وتخطوا الأخطاء التي ارتكبناها بالفعل." />
      <ArPageHero
        eyebrow="الحلول"
        h1="حلول جاهزة للتكييف"
        sub={SOLUTIONS_INDEX_INTRO_AR}
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "الحلول" }]}
      />

      <ArBlock tint="white">
        <div className="mb-2 text-xs font-semibold uppercase tracking-widest text-wafa-primary">
          معظم الجزء الصعب مبني بالفعل.
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((it) => (
            <Link
              key={it.slug}
              to={`/ar/solutions/${it.slug}`}
              data-testid={`index-card-ar-${it.slug}`}
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.25)]"
            >
              <div className="font-heading text-lg font-semibold text-wafa-deep group-hover:text-wafa-primary">
                {it.navLabel || it.h1}
              </div>
              {it.intro ? (
                <p className="mt-3 line-clamp-3 text-sm text-wafa-ink/70">
                  {it.intro.length > 160 ? it.intro.slice(0, 160) + "…" : it.intro}
                </p>
              ) : null}
              <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-wafa-deep">
                اقرأ المزيد <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
              </div>
            </Link>
          ))}
        </div>
      </ArBlock>

      <ArContactCTA heading="غير متأكدين أيها يناسبكم؟" />
    </div>
  );
}
